const TVCHANNEL = {
  list: [
    {
      id: 'mbcevery1',
      name: 'MBC EVERY1',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '1'
      }, {
        id: 'btv',
        no: '28'
      }, {
        id: 'lguplus',
        no: '29'
      }, {
        id: 'skylife',
        no: '0'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/mbcevery1.png'
    },
    {
      id: 'ssgshop',
      name: 'SSG SHOP',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '2'
      }, {
        id: 'btv',
        no: '22'
      }, {
        id: 'lguplus',
        no: '21'
      }, {
        id: 'skylife',
        no: '12'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ssgshop.png'
    },
    {
      id: 'mbcdramanet',
      name: 'MBC Dramanet',
      genre: 'drama',
      preset: [{
        id: 'ollehtv',
        no: '3'
      }, {
        id: 'btv',
        no: '32'
      }, {
        id: 'lguplus',
        no: '35'
      }, {
        id: 'skylife',
        no: '29'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/mbcdramanet.png'
    },
    {
      id: 'cjoshop',
      name: 'CJ O SHOP',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '4'
      }, {
        id: 'btv',
        no: '6'
      }, {
        id: 'lguplus',
        no: '8'
      }, {
        id: 'skylife',
        no: '8'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cjoshop.png'
    },
    {
      id: 'sbs',
      name: 'SBS',
      genre: 'terrestrial',
      preset: [{
        id: 'ollehtv',
        no: '5'
      }, {
        id: 'btv',
        no: '5'
      }, {
        id: 'lguplus',
        no: '5'
      }, {
        id: 'skylife',
        no: '5'
      }],
      no: '5',
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/sbs.png'
    },
    {
      id: 'lottehomeshop',
      name: 'Lotte Home SHOP',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '6'
      }, {
        id: 'btv',
        no: '10'
      }, {
        id: 'lguplus',
        no: '12'
      }, {
        id: 'skylife',
        no: '10'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/lottehomeshop.png'
    },
    {
      id: 'kbs2',
      name: 'KBS2',
      genre: 'terrestrial',
      preset: [{
        id: 'ollehtv',
        no: '7'
      }, {
        id: 'btv',
        no: '7'
      }, {
        id: 'lguplus',
        no: '7'
      }, {
        id: 'skylife',
        no: '7'
      }],
      no: '7',
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kbs2.png'
    },
    {
      id: 'gsshop',
      name: 'GS SHOP',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '8'
      }, {
        id: 'btv',
        no: '12'
      }, {
        id: 'lguplus',
        no: '6'
      }, {
        id: 'skylife',
        no: '14'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/gsshop.png'
    },
    {
      id: 'kbs1',
      name: 'KBS1',
      genre: 'terrestrial',
      preset: [{
        id: 'ollehtv',
        no: '9'
      }, {
        id: 'btv',
        no: '9'
      }, {
        id: 'lguplus',
        no: '9'
      }, {
        id: 'skylife',
        no: '9'
      }],
      no: '9',
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kbs1.png'
    },
    {
      id: 'hyundaishop',
      name: 'Hyundai SHOP',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '10'
      }, {
        id: 'btv',
        no: '8'
      }, {
        id: 'lguplus',
        no: '10'
      }, {
        id: 'skylife',
        no: '6'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/hyundaishop.png'
    },
    {
      id: 'mbc',
      name: 'MBC',
      genre: 'terrestrial',
      preset: [{
        id: 'ollehtv',
        no: '11'
      }, {
        id: 'btv',
        no: '11'
      }, {
        id: 'lguplus',
        no: '11'
      }, {
        id: 'skylife',
        no: '11'
      }],
      no: '11',
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/mbc.png'
    },
    {
      id: 'nshomeshop',
      name: 'NS home SHOP',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '12'
      }, {
        id: 'btv',
        no: '14'
      }, {
        id: 'lguplus',
        no: '13'
      }, {
        id: 'skylife',
        no: '17'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/nshomeshop.png'
    },
    {
      id: 'ebs',
      name: 'EBS',
      genre: 'terrestrial',
      preset: [{
        id: 'ollehtv',
        no: '13'
      }, {
        id: 'btv',
        no: '13'
      }, {
        id: 'lguplus',
        no: '14'
      }, {
        id: 'skylife',
        no: '3'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ebs.png'
    },
    {
      id: 'homeandshop',
      name: 'Home&SHOP',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '14'
      }, {
        id: 'btv',
        no: '4'
      }, {
        id: 'lguplus',
        no: '4'
      }, {
        id: 'skylife',
        no: '19'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/homeandshop.png'
    },
    {
      id: 'jtbc',
      name: 'JTBC',
      genre: 'totaltv',
      preset: [{
        id: 'ollehtv',
        no: '15'
      }, {
        id: 'btv',
        no: '15'
      }, {
        id: 'lguplus',
        no: '15'
      }, {
        id: 'skylife',
        no: '15'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/jtbc.png'
    },
    {
      id: 'mbn',
      name: 'MBN',
      genre: 'totaltv',
      preset: [{
        id: 'ollehtv',
        no: '16'
      }, {
        id: 'btv',
        no: '16'
      }, {
        id: 'lguplus',
        no: '16'
      }, {
        id: 'skylife',
        no: '16'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/mbn.png'
    },
    {
      id: 'tvn',
      name: 'tvN',
      genre: 'drama',
      preset: [{
        id: 'ollehtv',
        no: '17'
      }, {
        id: 'btv',
        no: '17'
      }, {
        id: 'lguplus',
        no: '17'
      }, {
        id: 'skylife',
        no: '20'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/tvn.png'
    },
    {
      id: 'channela',
      name: 'Channel A',
      genre: 'totaltv',
      preset: [{
        id: 'ollehtv',
        no: '18'
      }, {
        id: 'btv',
        no: '18'
      }, {
        id: 'lguplus',
        no: '18'
      }, {
        id: 'skylife',
        no: '13'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/channela.png'
    },
    {
      id: 'tvchosun',
      name: 'TV chosun',
      genre: 'totaltv',
      preset: [{
        id: 'ollehtv',
        no: '19'
      }, {
        id: 'btv',
        no: '19'
      }, {
        id: 'lguplus',
        no: '19'
      }, {
        id: 'skylife',
        no: '18'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/tvchosun.png'
    },
    {
      id: 'kshop',
      name: 'K SHOP',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '20'
      }, {
        id: 'btv',
        no: '25'
      }, {
        id: 'skylife',
        no: '4'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kshop.png'
    },
    {
      id: 'ocn',
      name: 'OCN',
      genre: 'movie',
      preset: [{
        id: 'ollehtv',
        no: '21'
      }, {
        id: 'btv',
        no: '54'
      }, {
        id: 'lguplus',
        no: '38'
      }, {
        id: 'skylife',
        no: '61'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ocn.png'
    },
    {
      id: 'imshop',
      name: 'Im SHOP',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '22'
      }, {
        id: 'btv',
        no: '3'
      }, {
        id: 'lguplus',
        no: '20'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/imshop.png'
    },
    {
      id: 'yonhapnewstv',
      name: 'Yonhapnews TV',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '23'
      }, {
        id: 'btv',
        no: '23'
      }, {
        id: 'lguplus',
        no: '23'
      }, {
        id: 'skylife',
        no: '23'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/yonhapnewstv.png'
    },
    {
      id: 'ytn',
      name: 'YTN',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '24'
      }, {
        id: 'btv',
        no: '24'
      }, {
        id: 'lguplus',
        no: '24'
      }, {
        id: 'skylife',
        no: '24'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ytn.png'
    },
    {
      id: 'sbscnbc',
      name: 'SBS CNBC',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '25'
      }, {
        id: 'btv',
        no: '27'
      }, {
        id: 'lguplus',
        no: '27'
      }, {
        id: 'skylife',
        no: '25'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/sbscnbc.png'
    },
    {
      id: 'obskyungin',
      name: 'OBS kyungin',
      genre: 'terrestrial',
      preset: [{
        id: 'ollehtv',
        no: '26'
      }, {
        id: 'btv',
        no: '20'
      }, {
        id: 'lguplus',
        no: '26'
      }, {
        id: 'skylife',
        no: '31'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/obskyungin.png'
    },
    {
      id: 'mnet',
      name: 'Mnet',
      genre: 'music',
      preset: [{
        id: 'ollehtv',
        no: '27'
      }, {
        id: 'btv',
        no: '27'
      }, {
        id: 'lguplus',
        no: '22'
      }, {
        id: 'skylife',
        no: '46'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/mnet.png'
    },
    {
      id: 'cjoshopplus',
      name: 'CJ O SHOP+',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '28'
      }, {
        id: 'btv',
        no: '33'
      }, {
        id: 'lguplus',
        no: '32'
      }, {
        id: 'skylife',
        no: '22'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cjoshopplus.png'
    },
    {
      id: 'chcgv',
      name: 'Ch. CGV',
      genre: 'movie',
      preset: [{
        id: 'ollehtv',
        no: '29'
      }, {
        id: 'btv',
        no: '53'
      }, {
        id: 'lguplus',
        no: '39'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/chcgv.png'
    },
    {
      id: 'skstoa',
      name: 'SK stoa',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '30'
      }, {
        id: 'btv',
        no: '21'
      }, {
        id: 'lguplus',
        no: '28'
      }, {
        id: 'skylife',
        no: '33'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/skstoa.png'
    },
    {
      id: 'skydrama',
      name: 'Sky drama',
      genre: 'drama',
      preset: [{
        id: 'ollehtv',
        no: '31'
      }, {
        id: 'btv',
        no: '40'
      }, {
        id: 'lguplus',
        no: '79'
      }, {
        id: 'skylife',
        no: '35'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/skydrama.png'
    },
    {
      id: 'superaction',
      name: 'Super Action',
      genre: 'movie',
      preset: [{
        id: 'ollehtv',
        no: '32'
      }, {
        id: 'btv',
        no: '55'
      }, {
        id: 'lguplus',
        no: '40'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/superaction.png'
    },
    {
      id: 'shopnt',
      name: 'SHOP & T',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '33'
      }, {
        id: 'btv',
        no: '31'
      }, {
        id: 'lguplus',
        no: '76'
      }, {
        id: 'skylife',
        no: '26'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/shopnt.png'
    },
    {
      id: 'olive',
      name: 'Olive',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '34'
      }, {
        id: 'btv',
        no: '84'
      }, {
        id: 'lguplus',
        no: '82'
      }, {
        id: 'skylife',
        no: '39'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/olive.png'
    },
    {
      id: 'kbsdrama',
      name: 'KBS Drama',
      genre: 'drama',
      preset: [{
        id: 'ollehtv',
        no: '35'
      }, {
        id: 'btv',
        no: '30'
      }, {
        id: 'lguplus',
        no: '31'
      }, {
        id: 'skylife',
        no: '27'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kbsdrama.png'
    },
    {
      id: 'hyundaihomeshopplus',
      name: 'Hyundai Home SHOP+',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '36'
      }, {
        id: 'btv',
        no: '39'
      }, {
        id: 'lguplus',
        no: '34'
      }, {
        id: 'skylife',
        no: '36'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/hyundaihomeshopplus.png'
    },
    {
      id: 'sbsplus',
      name: 'SBS Plus',
      genre: 'drama',
      preset: [{
        id: 'ollehtv',
        no: '37'
      }, {
        id: 'btv',
        no: '2'
      }, {
        id: 'lguplus',
        no: '33'
      }, {
        id: 'skylife',
        no: '32'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/sbsplus.png'
    },
    {
      id: 'gsmyshop',
      name: 'GS MY SHOP',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '38'
      }, {
        id: 'btv',
        no: '29'
      }, {
        id: 'lguplus',
        no: '30'
      }, {
        id: 'skylife',
        no: '28'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/gsmyshop.png'
    },
    {
      id: 'jtbc2',
      name: 'JTBC2',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '39'
      }, {
        id: 'btv',
        no: '82'
      }, {
        id: 'lguplus',
        no: '94'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/jtbc2.png'
    },
    {
      id: 'wshop',
      name: 'W SHOP',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '40'
      }, {
        id: 'btv',
        no: '37'
      }, {
        id: 'skylife',
        no: '2'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/wshop.png'
    },
    {
      id: 'kbsjoy',
      name: 'KBS Joy',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '41'
      }, {
        id: 'btv',
        no: '80'
      }, {
        id: 'lguplus',
        no: '3'
      }, {
        id: 'skylife',
        no: '1'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kbsjoy.png'
    },
    {
      id: 'nsshopplus',
      name: 'NS SHOP+',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '42'
      }, {
        id: 'btv',
        no: '41'
      }, {
        id: 'skylife',
        no: '34'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/nsshopplus.png'
    },
    {
      id: 'sbsfune',
      name: 'SBS funE',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '43'
      }, {
        id: 'btv',
        no: '81'
      }, {
        id: 'lguplus',
        no: '75'
      }, {
        id: 'skylife',
        no: '38'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/sbsfune.png'
    },
    {
      id: 'lotteonetv',
      name: 'Lotte one TV',
      genre: 'shopping',
      preset: [{
        id: 'ollehtv',
        no: '44'
      }, {
        id: 'btv',
        no: '35'
      }, {
        id: 'lguplus',
        no: '36'
      }, {
        id: 'skylife',
        no: '30'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/lotteonetv.png'
    },
    {
      id: 'otvn',
      name: 'O tvn',
      genre: 'drama',
      preset: [{
        id: 'ollehtv',
        no: '45'
      }, {
        id: 'btv',
        no: '34'
      }, {
        id: 'lguplus',
        no: '71'
      }, {
        id: 'skylife',
        no: '43'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/otvn.png'
    },
    {
      id: 'dramacube',
      name: 'Drama Cube',
      genre: 'drama',
      preset: [{
        id: 'ollehtv',
        no: '46'
      }, {
        id: 'btv',
        no: '36'
      }, {
        id: 'lguplus',
        no: '191'
      }, {
        id: 'skylife',
        no: '49'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/dramacube.png'
    },
    {
      id: 'dramax',
      name: 'Dramax',
      genre: 'drama',
      preset: [{
        id: 'ollehtv',
        no: '47'
      }, {
        id: 'btv',
        no: '38'
      }, {
        id: 'lguplus',
        no: '190'
      }, {
        id: 'skylife',
        no: '37'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/dramax.png'
    },
    {
      id: 'echannel',
      name: 'E Channel',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '48'
      }, {
        id: 'btv',
        no: '83'
      }, {
        id: 'lguplus',
        no: '104'
      }, {
        id: 'skylife',
        no: '44'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/echannel.png'
    },
    {
      id: 'skypetpark',
      name: 'Sky pet park',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '49'
      }, {
        id: 'btv',
        no: '94'
      }, {
        id: 'lguplus',
        no: '114'
      }, {
        id: 'skylife',
        no: '42'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/skypetpark.png'
    },
    {
      id: 'skyent',
      name: 'Sky ENT',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '50'
      }, {
        id: 'skylife',
        no: '52'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/skyent.png'
    },
    {
      id: 'spotv',
      name: 'SPOTV',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '51'
      }, {
        id: 'btv',
        no: '120'
      }, {
        id: 'lguplus',
        no: '56'
      }, {
        id: 'skylife',
        no: '100'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/spotv.png'
    },
    {
      id: 'spotv2',
      name: 'SPOTV2',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '52'
      }, {
        id: 'btv',
        no: '128'
      }, {
        id: 'lguplus',
        no: '52'
      }, {
        id: 'skylife',
        no: '124'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/spotv2.png'
    },
    {
      id: 'ibsports',
      name: 'IB SPORTS',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '53'
      }, {
        id: 'btv',
        no: '129'
      }, {
        id: 'lguplus',
        no: '62'
      }, {
        id: 'skylife',
        no: '110'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ibsports.png'
    },
    {
      id: 'skysports',
      name: 'SkySports',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '54'
      }, {
        id: 'btv',
        no: '125'
      }, {
        id: 'lguplus',
        no: '57'
      }, {
        id: 'skylife',
        no: '101'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/skysports.png'
    },
    {
      id: 'thegolfchannel',
      name: 'The Golf Channel',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '55'
      }, {
        id: 'btv',
        no: '133'
      }, {
        id: 'lguplus',
        no: '55'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/thegolfchannel.png'
    },
    {
      id: 'jtbcgolf',
      name: 'JTBC Golf',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '56'
      }, {
        id: 'btv',
        no: '132'
      }, {
        id: 'lguplus',
        no: '54'
      }, {
        id: 'skylife',
        no: '106'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/jtbcgolf.png'
    },
    {
      id: 'sbsgolf',
      name: 'SBS GOLF',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '57'
      }, {
        id: 'btv',
        no: '131'
      }, {
        id: 'lguplus',
        no: '53'
      }, {
        id: 'skylife',
        no: '107'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/sbsgolf.png'
    },
    {
      id: 'sbssports',
      name: 'SBS Sports',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '58'
      }, {
        id: 'btv',
        no: '122'
      }, {
        id: 'lguplus',
        no: '58'
      }, {
        id: 'skylife',
        no: '103'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/sbssports.png'
    },
    {
      id: 'kbsnsports',
      name: 'KBS N Sports',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '59'
      }, {
        id: 'btv',
        no: '121'
      }, {
        id: 'lguplus',
        no: '59'
      }, {
        id: 'skylife',
        no: '102'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kbsnsports.png'
    },
    {
      id: 'mbcsportplus',
      name: 'MBC SPORT +',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '60'
      }, {
        id: 'btv',
        no: '123'
      }, {
        id: 'lguplus',
        no: '60'
      }, {
        id: 'skylife',
        no: '104'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/mbcsportplus.png'
    },
    {
      id: 'mbcsportplus2',
      name: 'MBC SPORT +2',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '61'
      }, {
        id: 'btv',
        no: '124'
      }, {
        id: 'lguplus',
        no: '61'
      }, {
        id: 'skylife',
        no: '105'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/mbcsportplus2.png'
    },
    {
      id: 'jtbc3',
      name: 'JTBC3',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '62'
      }, {
        id: 'btv',
        no: '126'
      }, {
        id: 'lguplus',
        no: '50'
      }, {
        id: 'skylife',
        no: '108'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/jtbc3.png'
    },
    {
      id: 'starsports',
      name: 'Star Sports',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '63'
      }, {
        id: 'btv',
        no: '135'
      }, {
        id: 'skylife',
        no: '174'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/starsports.png'
    },
    {
      id: 'ktv',
      name: 'KTV',
      genre: 'public',
      preset: [{
        id: 'ollehtv',
        no: '64'
      }, {
        id: 'btv',
        no: '290'
      }, {
        id: 'skylife',
        no: '161'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ktv.png'
    },
    {
      id: 'assemblytv',
      name: 'Assembly TV',
      genre: 'public',
      preset: [{
        id: 'ollehtv',
        no: '65'
      }, {
        id: 'btv',
        no: '291'
      }, {
        id: 'lguplus',
        no: '172'
      }, {
        id: 'skylife',
        no: '162'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/assemblytv.png'
    },
    {
      id: 'catchon1',
      name: 'CATCH ON1',
      genre: 'movie',
      preset: [{
        id: 'ollehtv',
        no: '66'
      }, {
        id: 'btv',
        no: '51'
      }, {
        id: 'lguplus',
        no: '48'
      }, {
        id: 'skylife',
        no: '62'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/catchon1.png'
    },
    {
      id: 'catchon2',
      name: 'CATCH ON2',
      genre: 'movie',
      preset: [{
        id: 'ollehtv',
        no: '67'
      }, {
        id: 'btv',
        no: '52'
      }, {
        id: 'lguplus',
        no: '49'
      }, {
        id: 'skylife',
        no: '63'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/catchon2.png'
    },
    {
      id: 'cntv',
      name: 'CNTV',
      genre: 'drama',
      preset: [{
        id: 'ollehtv',
        no: '68'
      }, {
        id: 'btv',
        no: '43'
      }, {
        id: 'lguplus',
        no: '85'
      }, {
        id: 'skylife',
        no: '47'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cntv.png'
    },
    {
      id: 'ctime',
      name: 'C TIME',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '69'
      }, {
        id: 'btv',
        no: '86'
      }, {
        id: 'lguplus',
        no: '86'
      }, {
        id: 'skylife',
        no: '116'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ctime.png'
    },
    {
      id: 'dramah',
      name: 'Drama H',
      genre: 'drama',
      preset: [{
        id: 'ollehtv',
        no: '70'
      }, {
        id: 'btv',
        no: '46'
      }, {
        id: 'lguplus',
        no: '192'
      }, {
        id: 'skylife',
        no: '51'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/dramah.png'
    },
    {
      id: 'funtv',
      name: 'FUN TV',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '71'
      }, {
        id: 'btv',
        no: '91'
      }, {
        id: 'lguplus',
        no: '194'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/funtv.png'
    },
    {
      id: 'diatv',
      name: 'DIA TV',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '72'
      }, {
        id: 'btv',
        no: '96'
      }, {
        id: 'lguplus',
        no: '93'
      }, {
        id: 'skylife',
        no: '160'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/diatv.png'
    },
    {
      id: 'gtv',
      name: 'GTV',
      genre: 'life',
      preset: [{
        id: 'ollehtv',
        no: '73'
      }, {
        id: 'btv',
        no: '217'
      }, {
        id: 'lguplus',
        no: '136'
      }, {
        id: 'skylife',
        no: '55'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/gtv.png'
    },
    {
      id: 'highlighttv',
      name: 'Highlight TV',
      genre: 'drama',
      preset: [{
        id: 'ollehtv',
        no: '74'
      }, {
        id: 'btv',
        no: '42'
      }, {
        id: 'lguplus',
        no: '91'
      }, {
        id: 'skylife',
        no: '137'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/highlighttv.png'
    },
    {
      id: 'xtvn',
      name: 'X tvN',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '76'
      }, {
        id: 'btv',
        no: '85'
      }, {
        id: 'lguplus',
        no: '72'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/xtvn.png'
    },
    {
      id: 'onstyle',
      name: 'On Style',
      genre: 'life',
      preset: [{
        id: 'ollehtv',
        no: '77'
      }, {
        id: 'btv',
        no: '210'
      }, {
        id: 'lguplus',
        no: '73'
      }, {
        id: 'skylife',
        no: '85'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/onstyle.png'
    },
    {
      id: 'lifetime',
      name: 'Life time',
      genre: 'life',
      preset: [{
        id: 'ollehtv',
        no: '78'
      }, {
        id: 'btv',
        no: '213'
      }, {
        id: 'lguplus',
        no: '83'
      }, {
        id: 'skylife',
        no: '86'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/lifetime.png'
    },
    {
      id: 'edgetv',
      name: 'Edge TV',
      genre: 'drama',
      preset: [{
        id: 'ollehtv',
        no: '79'
      }, {
        id: 'btv',
        no: '44'
      }, {
        id: 'lguplus',
        no: '68'
      }, {
        id: 'skylife',
        no: '83'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/edgetv.png'
    },
    {
      id: 'skyaandc',
      name: 'Sky A&C',
      genre: 'life',
      preset: [{
        id: 'ollehtv',
        no: '80'
      }, {
        id: 'skylife',
        no: '57'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/skyaandc.png'
    },
    {
      id: 'hdobsw',
      name: 'HD OBS W',
      genre: 'life',
      preset: [{
        id: 'ollehtv',
        no: '81'
      }, {
        id: 'btv',
        no: '219'
      }, {
        id: 'lguplus',
        no: '137'
      }, {
        id: 'skylife',
        no: '136'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/hdobsw.png'
    },
    {
      id: 'dongatv',
      name: 'Donga TV',
      genre: 'life',
      preset: [{
        id: 'ollehtv',
        no: '82'
      }, {
        id: 'btv',
        no: '218'
      }, {
        id: 'lguplus',
        no: '84'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/dongatv.png'
    },
    {
      id: 'kbsw',
      name: 'KBS W',
      genre: 'life',
      preset: [{
        id: 'ollehtv',
        no: '83'
      }, {
        id: 'btv',
        no: '214'
      }, {
        id: 'lguplus',
        no: '77'
      }, {
        id: 'skylife',
        no: '87'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kbsw.png'
    },
    {
      id: 'smiletv',
      name: 'Smile TV',
      genre: 'life',
      preset: [{
        id: 'ollehtv',
        no: '84'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/smiletv.png'
    },
    {
      id: 'comedytv',
      name: 'Comedy TV',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '85'
      }, {
        id: 'btv',
        no: '87'
      }, {
        id: 'lguplus',
        no: '109'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/comedytv.png'
    },
    {
      id: 'kstar',
      name: 'K STAR',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '87'
      }, {
        id: 'btv',
        no: '88'
      }, {
        id: 'lguplus',
        no: '105'
      }, {
        id: 'skylife',
        no: '48'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kstar.png'
    },
    {
      id: 'gmtv',
      name: 'GMTV',
      genre: 'music',
      preset: [{
        id: 'ollehtv',
        no: '88'
      }, {
        id: 'btv',
        no: '232'
      }, {
        id: 'lguplus',
        no: '101'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/gmtv.png'
    },
    {
      id: 'channelv',
      name: 'Channel [V]',
      genre: 'music',
      preset: [{
        id: 'ollehtv',
        no: '89'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/channelv.png'
    },
    {
      id: 'classica',
      name: 'Classica',
      genre: 'music',
      preset: [{
        id: 'ollehtv',
        no: '90'
      }, {
        id: 'btv',
        no: '235'
      }, {
        id: 'lguplus',
        no: '146'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/classica.png'
    },
    {
      id: 'tvarte',
      name: 'TV arte',
      genre: 'music',
      preset: [{
        id: 'ollehtv',
        no: '91'
      }, {
        id: 'btv',
        no: '234'
      }, {
        id: 'lguplus',
        no: '139'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/tvarte.png'
    },
    {
      id: 'inettv',
      name: 'i net TV',
      genre: 'music',
      preset: [{
        id: 'ollehtv',
        no: '92'
      }, {
        id: 'btv',
        no: '233'
      }, {
        id: 'lguplus',
        no: '106'
      }, {
        id: 'skylife',
        no: '99'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/inettv.png'
    },
    {
      id: 'gayotv',
      name: 'Gayo TV',
      genre: 'music',
      preset: [{
        id: 'ollehtv',
        no: '93'
      }, {
        id: 'lguplus',
        no: '102'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/gayotv.png'
    },
    {
      id: 'nowjejutv',
      name: 'Now JEJU TV',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '94'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/nowjejutv.png'
    },
    {
      id: 'ebs2',
      name: 'EBS2',
      genre: 'terrestrial',
      preset: [{
        id: 'ollehtv',
        no: '95'
      }, {
        id: 'btv',
        no: '95'
      }, {
        id: 'lguplus',
        no: '95'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ebs2.png'
    },
    {
      id: 'sbsmtv',
      name: 'SBS MTV',
      genre: 'music',
      preset: [{
        id: 'ollehtv',
        no: '96'
      }, {
        id: 'btv',
        no: '230'
      }, {
        id: 'lguplus',
        no: '100'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/sbsmtv.png'
    },
    {
      id: 'mbcmusic',
      name: 'MBC MUSIC',
      genre: 'music',
      preset: [{
        id: 'ollehtv',
        no: '97'
      }, {
        id: 'btv',
        no: '231'
      }, {
        id: 'lguplus',
        no: '99'
      }, {
        id: 'skylife',
        no: '112'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/mbcmusic.png'
    },
    {
      id: 'channelaplus',
      name: 'Channel A+',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '98'
      }, {
        id: 'btv',
        no: '97'
      }, {
        id: 'lguplus',
        no: '115'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/channelaplus.png'
    },
    {
      id: 'mbnplus',
      name: 'MBN Plus',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '99'
      }, {
        id: 'btv',
        no: '98'
      }, {
        id: 'lguplus',
        no: '116'
      }, {
        id: 'skylife',
        no: '119'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/mbnplus.png'
    },
    {
      id: 'skytravel',
      name: 'SkyTravel',
      genre: 'hobby',
      preset: [{
        id: 'ollehtv',
        no: '100'
      }, {
        id: 'btv',
        no: '246'
      }, {
        id: 'lguplus',
        no: '66'
      }, {
        id: 'skylife',
        no: '56'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/skytravel.png'
    },
    {
      id: 'channelchina',
      name: 'Channel China',
      genre: 'series',
      preset: [{
        id: 'ollehtv',
        no: '102'
      }, {
        id: 'btv',
        no: '108'
      }, {
        id: 'lguplus',
        no: '80'
      }, {
        id: 'skylife',
        no: '80'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/channelchina.png'
    },
    {
      id: 'mplex',
      name: 'Mplex',
      genre: 'movie',
      preset: [{
        id: 'ollehtv',
        no: '103'
      }, {
        id: 'btv',
        no: '57'
      }, {
        id: 'lguplus',
        no: '46'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/mplex.png'
    },
    {
      id: 'themovie',
      name: 'THE MOVIE',
      genre: 'movie',
      preset: [{
        id: 'ollehtv',
        no: '104'
      }, {
        id: 'btv',
        no: '59'
      }, {
        id: 'lguplus',
        no: '47'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/themovie.png'
    },
    {
      id: 'screen',
      name: 'Screen',
      genre: 'movie',
      preset: [{
        id: 'ollehtv',
        no: '106'
      }, {
        id: 'btv',
        no: '56'
      }, {
        id: 'lguplus',
        no: '41'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/screen.png'
    },
    {
      id: 'fox',
      name: 'FOX',
      genre: 'series',
      preset: [{
        id: 'ollehtv',
        no: '107'
      }, {
        id: 'btv',
        no: '101'
      }, {
        id: 'lguplus',
        no: '44'
      }, {
        id: 'skylife',
        no: '74'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/fox.png'
    },
    {
      id: 'channelj',
      name: 'Channel J',
      genre: 'series',
      preset: [{
        id: 'ollehtv',
        no: '108'
      }, {
        id: 'btv',
        no: '103'
      }, {
        id: 'lguplus',
        no: '145'
      }, {
        id: 'skylife',
        no: '79'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/channelj.png'
    },
    {
      id: 'chinatv',
      name: 'China TV',
      genre: 'series',
      preset: [{
        id: 'ollehtv',
        no: '110'
      }, {
        id: 'btv',
        no: '104'
      }, {
        id: 'lguplus',
        no: '87'
      }, {
        id: 'skylife',
        no: '77'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/chinatv.png'
    },
    {
      id: 'asian',
      name: 'Asia N',
      genre: 'series',
      preset: [{
        id: 'ollehtv',
        no: '111'
      }, {
        id: 'btv',
        no: '106'
      }, {
        id: 'lguplus',
        no: '88'
      }, {
        id: 'skylife',
        no: '53'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/asian.png'
    },
    {
      id: 'heroaction',
      name: 'Hero Action',
      genre: 'series',
      preset: [{
        id: 'ollehtv',
        no: '112'
      }, {
        id: 'btv',
        no: '107'
      }, {
        id: 'lguplus',
        no: '110'
      }, {
        id: 'skylife',
        no: '78'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/heroaction.png'
    },
    {
      id: 'axn',
      name: 'AXN',
      genre: 'series',
      preset: [{
        id: 'ollehtv',
        no: '113'
      }, {
        id: 'btv',
        no: '102'
      }, {
        id: 'lguplus',
        no: '45'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/axn.png'
    },
    {
      id: 'telenovela',
      name: 'Telenovela',
      genre: 'series',
      preset: [{
        id: 'ollehtv',
        no: '114'
      }, {
        id: 'btv',
        no: '109'
      }, {
        id: 'lguplus',
        no: '81'
      }, {
        id: 'skylife',
        no: '75'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/telenovela.png'
    },
    {
      id: 'donetv',
      name: 'D-one TV',
      genre: 'drama',
      preset: [{
        id: 'ollehtv',
        no: '115'
      }, {
        id: 'btv',
        no: '45'
      }, {
        id: 'lguplus',
        no: '90'
      }, {
        id: 'skylife',
        no: '117'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/donetv.png'
    },
    {
      id: 'billiardstv',
      name: 'Billiards TV',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '116'
      }, {
        id: 'btv',
        no: '130'
      }, {
        id: 'lguplus',
        no: '63'
      }, {
        id: 'skylife',
        no: '111'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/billiardstv.png'
    },
    {
      id: 'mountaintv',
      name: 'Mountain TV',
      genre: 'hobby',
      preset: [{
        id: 'ollehtv',
        no: '117'
      }, {
        id: 'btv',
        no: '247'
      }, {
        id: 'lguplus',
        no: '69'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/mountaintv.png'
    },
    {
      id: 'ftv',
      name: 'FTV',
      genre: 'hobby',
      preset: [{
        id: 'ollehtv',
        no: '118'
      }, {
        id: 'btv',
        no: '243'
      }, {
        id: 'lguplus',
        no: '64'
      }, {
        id: 'skylife',
        no: '122'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ftv.png'
    },
    {
      id: 'fishingtv',
      name: 'FISHING TV',
      genre: 'hobby',
      preset: [{
        id: 'ollehtv',
        no: '119'
      }, {
        id: 'btv',
        no: '244'
      }, {
        id: 'lguplus',
        no: '65'
      }, {
        id: 'skylife',
        no: '121'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/fishingtv.png'
    },
    {
      id: 'baduktv',
      name: 'Baduk TV',
      genre: 'hobby',
      preset: [{
        id: 'ollehtv',
        no: '120'
      }, {
        id: 'btv',
        no: '240'
      }, {
        id: 'lguplus',
        no: '97'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/baduktv.png'
    },
    {
      id: 'kbaduk',
      name: 'K- Baduk',
      genre: 'hobby',
      preset: [{
        id: 'ollehtv',
        no: '121'
      }, {
        id: 'btv',
        no: '241'
      }, {
        id: 'lguplus',
        no: '107'
      }, {
        id: 'skylife',
        no: '140'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kbaduk.png'
    },
    {
      id: 'braintv',
      name: 'Brain TV',
      genre: 'hobby',
      preset: [{
        id: 'ollehtv',
        no: '122'
      }, {
        id: 'btv',
        no: '242'
      }, {
        id: 'lguplus',
        no: '98'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/braintv.png'
    },
    {
      id: 'ogn',
      name: 'OGN',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '123'
      }, {
        id: 'btv',
        no: '136'
      }, {
        id: 'lguplus',
        no: '96'
      }, {
        id: 'skylife',
        no: '159'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ogn.png'
    },
    {
      id: 'spotvgames',
      name: 'SPOTV Games',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '124'
      }, {
        id: 'btv',
        no: '137'
      }, {
        id: 'lguplus',
        no: '109'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/spotvgames.png'
    },
    {
      id: 'spotvplus',
      name: 'SPOTV+',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '125'
      }, {
        id: 'btv',
        no: '127'
      }, {
        id: 'lguplus',
        no: '51'
      }, {
        id: 'skylife',
        no: '109'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/spotvplus.png'
    },
    {
      id: 'cmcenttv',
      name: 'CMC Ent TV',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '126'
      }, {
        id: 'btv',
        no: '93'
      }, {
        id: 'lguplus',
        no: '193'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cmcenttv.png'
    },
    {
      id: 'realtv',
      name: 'Real TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '127'
      }, {
        id: 'btv',
        no: '267'
      }, {
        id: 'lguplus',
        no: '128'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/realtv.png'
    },
    {
      id: 'nolltv',
      name: 'Noll TV',
      genre: 'hobby',
      preset: [{
        id: 'ollehtv',
        no: '128'
      }, {
        id: 'btv',
        no: '248'
      }, {
        id: 'lguplus',
        no: '92'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/nolltv.png'
    },
    {
      id: 'pollaristv',
      name: 'Pollaris TV',
      genre: 'hobby',
      preset: [{
        id: 'ollehtv',
        no: '129'
      }, {
        id: 'btv',
        no: '249'
      }, {
        id: 'lguplus',
        no: '67'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/pollaristv.png'
    },
    {
      id: 'disneychannel',
      name: 'Disney Channel',
      genre: 'animation',
      preset: [{
        id: 'ollehtv',
        no: '130'
      }, {
        id: 'btv',
        no: '171'
      }, {
        id: 'lguplus',
        no: '150'
      }, {
        id: 'skylife',
        no: '150'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/disneychannel.png'
    },
    {
      id: 'dreamworkschannel',
      name: 'Dream Works Channel',
      genre: 'animation',
      preset: [{
        id: 'ollehtv',
        no: '131'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/dreamworkschannel.png'
    },
    {
      id: 'tooniverse',
      name: 'Tooniverse',
      genre: 'animation',
      preset: [{
        id: 'ollehtv',
        no: '132'
      }, {
        id: 'btv',
        no: '170'
      }, {
        id: 'lguplus',
        no: '152'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/tooniverse.png'
    },
    {
      id: 'animax',
      name: 'ANIMAX',
      genre: 'animation',
      preset: [{
        id: 'ollehtv',
        no: '133'
      }, {
        id: 'btv',
        no: '173'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/animax.png'
    },
    {
      id: 'anyone',
      name: 'AnyOne',
      genre: 'animation',
      preset: [{
        id: 'ollehtv',
        no: '134'
      }, {
        id: 'btv',
        no: '174'
      }, {
        id: 'lguplus',
        no: '153'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/anyone.png'
    },
    {
      id: 'anybox',
      name: 'AnyBox',
      genre: 'animation',
      preset: [{
        id: 'ollehtv',
        no: '135'
      }, {
        id: 'btv',
        no: '179'
      }, {
        id: 'lguplus',
        no: '148'
      }, {
        id: 'skylife',
        no: '151'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/anybox.png'
    },
    {
      id: 'nickelodeon',
      name: 'Nickelodeon',
      genre: 'animation',
      preset: [{
        id: 'ollehtv',
        no: '136'
      }, {
        id: 'btv',
        no: '176'
      }, {
        id: 'skylife',
        no: '152'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/nickelodeon.png'
    },
    {
      id: 'cartoonnetwork',
      name: 'Cartoon Network',
      genre: 'animation',
      preset: [{
        id: 'ollehtv',
        no: '137'
      }, {
        id: 'btv',
        no: '177'
      }, {
        id: 'lguplus',
        no: '155'
      }, {
        id: 'skylife',
        no: '154'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cartoonnetwork.png'
    },
    {
      id: 'anyplus',
      name: 'AnyPlus',
      genre: 'animation',
      preset: [{
        id: 'ollehtv',
        no: '138'
      }, {
        id: 'btv',
        no: '178'
      }, {
        id: 'lguplus',
        no: '149'
      }, {
        id: 'skylife',
        no: '157'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/anyplus.png'
    },
    {
      id: 'boomerang',
      name: 'Boomerang',
      genre: 'animation',
      preset: [{
        id: 'ollehtv',
        no: '139'
      }, {
        id: 'btv',
        no: '175'
      }, {
        id: 'lguplus',
        no: '166'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/boomerang.png'
    },
    {
      id: 'daegyokidstv',
      name: 'Daegyo Kids TV',
      genre: 'kids',
      preset: [{
        id: 'ollehtv',
        no: '141'
      }, {
        id: 'btv',
        no: '191'
      }, {
        id: 'lguplus',
        no: '156'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/daegyokidstv.png'
    },
    {
      id: 'jeitv',
      name: 'JEI TV',
      genre: 'kids',
      preset: [{
        id: 'ollehtv',
        no: '142'
      }, {
        id: 'btv',
        no: '192'
      }, {
        id: 'lguplus',
        no: '159'
      }, {
        id: 'skylife',
        no: '156'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/jeitv.png'
    },
    {
      id: 'carrytv',
      name: 'Carry TV',
      genre: 'kids',
      preset: [{
        id: 'ollehtv',
        no: '143'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/carrytv.png'
    },
    {
      id: 'kbskids',
      name: 'KBS Kids',
      genre: 'kids',
      preset: [{
        id: 'ollehtv',
        no: '144'
      }, {
        id: 'btv',
        no: '190'
      }, {
        id: 'lguplus',
        no: '169'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kbskids.png'
    },
    {
      id: 'ebskids',
      name: 'EBS KIDS',
      genre: 'kids',
      preset: [{
        id: 'ollehtv',
        no: '145'
      }, {
        id: 'btv',
        no: '194'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ebskids.png'
    },
    {
      id: 'babytv',
      name: 'Baby TV',
      genre: 'kids',
      preset: [{
        id: 'ollehtv',
        no: '146'
      }, {
        id: 'btv',
        no: '195'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/babytv.png'
    },
    {
      id: 'kidsone',
      name: 'Kids One',
      genre: 'kids',
      preset: [{
        id: 'ollehtv',
        no: '148'
      }, {
        id: 'btv',
        no: '193'
      }, {
        id: 'lguplus',
        no: '157'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kidsone.png'
    },
    {
      id: 'kidstv',
      name: 'KIDS TV',
      genre: 'kids',
      preset: [{
        id: 'ollehtv',
        no: '149'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kidstv.png'
    },
    {
      id: 'disneyjunior',
      name: 'Disney Junior',
      genre: 'animation',
      preset: [{
        id: 'ollehtv',
        no: '151'
      }, {
        id: 'btv',
        no: '172'
      }, {
        id: 'lguplus',
        no: '151'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/disneyjunior.png'
    },
    {
      id: 'cbeebies',
      name: 'Cbeebies',
      genre: 'kids',
      preset: [{
        id: 'ollehtv',
        no: '152'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cbeebies.png'
    },
    {
      id: 'jeienglishtv',
      name: 'JEI English TV',
      genre: 'education',
      preset: [{
        id: 'ollehtv',
        no: '154'
      }, {
        id: 'btv',
        no: '200'
      }, {
        id: 'lguplus',
        no: '160'
      }, {
        id: 'skylife',
        no: '158'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/jeienglishtv.png'
    },
    {
      id: 'playruntv',
      name: 'Playrun TV',
      genre: 'education',
      preset: [{
        id: 'ollehtv',
        no: '155'
      }, {
        id: 'btv',
        no: '201'
      }, {
        id: 'lguplus',
        no: '161'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/playruntv.png'
    },
    {
      id: 'ebsenglish',
      name: 'EBS English',
      genre: 'education',
      preset: [{
        id: 'ollehtv',
        no: '156'
      }, {
        id: 'btv',
        no: '202'
      }, {
        id: 'lguplus',
        no: '162'
      }, {
        id: 'skylife',
        no: '170'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ebsenglish.png'
    },
    {
      id: 'ebsplus1',
      name: 'EBS PLUS1',
      genre: 'education',
      preset: [{
        id: 'ollehtv',
        no: '157'
      }, {
        id: 'btv',
        no: '203'
      }, {
        id: 'lguplus',
        no: '163'
      }, {
        id: 'skylife',
        no: '168'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ebsplus1.png'
    },
    {
      id: 'ebsplus2',
      name: 'EBS PLUS2',
      genre: 'education',
      preset: [{
        id: 'ollehtv',
        no: '158'
      }, {
        id: 'btv',
        no: '204'
      }, {
        id: 'lguplus',
        no: '164'
      }, {
        id: 'skylife',
        no: '169'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ebsplus2.png'
    },
    {
      id: 'edutv',
      name: 'edu TV',
      genre: 'education',
      preset: [{
        id: 'ollehtv',
        no: '159'
      }, {
        id: 'btv',
        no: '205'
      }, {
        id: 'lguplus',
        no: '165'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/edutv.png'
    },
    {
      id: 'oun',
      name: 'OUN',
      genre: 'public',
      preset: [{
        id: 'ollehtv',
        no: '160'
      }, {
        id: 'btv',
        no: '292'
      }, {
        id: 'lguplus',
        no: '170'
      }, {
        id: 'skylife',
        no: '167'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/oun.png'
    },
    {
      id: 'kidstoktokplus',
      name: 'Kids TokTok plus',
      genre: 'kids',
      preset: [{
        id: 'ollehtv',
        no: '161'
      }, {
        id: 'btv',
        no: '189'
      }, {
        id: 'lguplus',
        no: '158'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kidstoktokplus.png'
    },
    {
      id: '9colors',
      name: '9Colors',
      genre: 'life',
      preset: [{
        id: 'ollehtv',
        no: '163'
      }, {
        id: 'btv',
        no: '220'
      }, {
        id: 'lguplus',
        no: '178'
      }, {
        id: 'skylife',
        no: '186'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/9colors.png'
    },
    {
      id: 'mbcnet',
      name: 'MBC NET',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '164'
      }, {
        id: 'btv',
        no: '274'
      }, {
        id: 'lguplus',
        no: '140'
      }, {
        id: 'skylife',
        no: '138'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/mbcnet.png'
    },
    {
      id: 'skyict',
      name: 'Sky ICT',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '165'
      }, {
        id: 'skylife',
        no: '115'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/skyict.png'
    },
    {
      id: 'environmenttv',
      name: 'Environment TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '166'
      }, {
        id: 'btv',
        no: '276'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/environmenttv.png'
    },
    {
      id: 'skyhealing',
      name: 'Sky Healing',
      genre: 'life',
      preset: [{
        id: 'ollehtv',
        no: '167'
      }, {
        id: 'skylife',
        no: '81'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/skyhealing.png'
    },
    {
      id: 'ngc',
      name: 'NGC',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '168'
      }, {
        id: 'btv',
        no: '260'
      }, {
        id: 'lguplus',
        no: '131'
      }, {
        id: 'skylife',
        no: '127'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ngc.png'
    },
    {
      id: 'history',
      name: 'History',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '169'
      }, {
        id: 'btv',
        no: '264'
      }, {
        id: 'lguplus',
        no: '132'
      }, {
        id: 'skylife',
        no: '131'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/history.png'
    },
    {
      id: 'natgeowild',
      name: 'Nat Geo Wild',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '170'
      }, {
        id: 'btv',
        no: '266'
      }, {
        id: 'lguplus',
        no: '134'
      }, {
        id: 'skylife',
        no: '128'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/natgeowild.png'
    },
    {
      id: 'natgeopeople',
      name: 'Nat Geo People',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '171'
      }, {
        id: 'btv',
        no: '263'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/natgeopeople.png'
    },
    {
      id: 'bbcearth',
      name: 'BBC Earth',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '172'
      }, {
        id: 'btv',
        no: '265'
      }, {
        id: 'lguplus',
        no: '130'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/bbcearth.png'
    },
    {
      id: 'extremefun',
      name: 'Extreme Fun',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '173'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/extremefun.png'
    },
    {
      id: 'ytnscience',
      name: 'YTN Science',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '175'
      }, {
        id: 'btv',
        no: '262'
      }, {
        id: 'lguplus',
        no: '25'
      }, {
        id: 'skylife',
        no: '126'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ytnscience.png'
    },
    {
      id: 'channelview',
      name: 'Channel View',
      genre: 'life',
      preset: [{
        id: 'ollehtv',
        no: '176'
      }, {
        id: 'btv',
        no: '212'
      }, {
        id: 'lguplus',
        no: '127'
      }, {
        id: 'skylife',
        no: '89'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/channelview.png'
    },
    {
      id: 'discoverychannel',
      name: 'Discovery Channel',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '177'
      }, {
        id: 'btv',
        no: '261'
      }, {
        id: 'lguplus',
        no: '133'
      }, {
        id: 'skylife',
        no: '130'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/discoverychannel.png'
    },
    {
      id: 'animalplanet',
      name: 'Animal Planet',
      genre: 'life',
      preset: [{
        id: 'ollehtv',
        no: '179'
      }, {
        id: 'skylife',
        no: '129'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/animalplanet.png'
    },
    {
      id: 'koreafinancialtv',
      name: 'Korea Financial TV',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '180'
      }, {
        id: 'btv',
        no: '151'
      }, {
        id: 'lguplus',
        no: '121'
      }, {
        id: 'skylife',
        no: '91'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/koreafinancialtv.png'
    },
    {
      id: 'moneytodaybroadc',
      name: 'Money Today Broadc.',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '181'
      }, {
        id: 'btv',
        no: '152'
      }, {
        id: 'skylife',
        no: '92'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/moneytodaybroadc.png'
    },
    {
      id: 'maeilfinancialtv',
      name: 'Maeil Financial TV',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '182'
      }, {
        id: 'btv',
        no: '153'
      }, {
        id: 'lguplus',
        no: '112'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/maeilfinancialtv.png'
    },
    {
      id: 'edailytv',
      name: 'edaily TV',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '183'
      }, {
        id: 'btv',
        no: '155'
      }, {
        id: 'lguplus',
        no: '123'
      }, {
        id: 'skylife',
        no: '93'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/edailytv.png'
    },
    {
      id: 'seoulfinacialtv',
      name: 'Seoul Finacial TV',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '184'
      }, {
        id: 'btv',
        no: '156'
      }, {
        id: 'lguplus',
        no: '124'
      }, {
        id: 'skylife',
        no: '97'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/seoulfinacialtv.png'
    },
    {
      id: 'tomatotv',
      name: 'Tomato TV',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '185'
      }, {
        id: 'btv',
        no: '150'
      }, {
        id: 'lguplus',
        no: '111'
      }, {
        id: 'skylife',
        no: '94'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/tomatotv.png'
    },
    {
      id: 'asiafinancialtv',
      name: 'Asia Financial TV',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '186'
      }, {
        id: 'btv',
        no: '154'
      }, {
        id: 'lguplus',
        no: '113'
      }, {
        id: 'skylife',
        no: '96'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/asiafinancialtv.png'
    },
    {
      id: 'estatetomato',
      name: 'Estate Tomato',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '188'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/estatetomato.png'
    },
    {
      id: 'ytnlife',
      name: 'YTN life',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '190'
      }, {
        id: 'btv',
        no: '157'
      }, {
        id: 'lguplus',
        no: '125'
      }, {
        id: 'skylife',
        no: '90'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ytnlife.png'
    },
    {
      id: 'cnninternational',
      name: 'CNN International',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '191'
      }, {
        id: 'btv',
        no: '158'
      }, {
        id: 'lguplus',
        no: '117'
      }, {
        id: 'skylife',
        no: '172'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cnninternational.png'
    },
    {
      id: 'bbcwn',
      name: 'BBC World News',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '192'
      }, {
        id: 'btv',
        no: '160'
      }, {
        id: 'lguplus',
        no: '126'
      }, {
        id: 'skylife',
        no: '173'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/bbcwn.png'
    },
    {
      id: 'euronews',
      name: 'Euro News',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '193'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/euronews.png'
    },
    {
      id: 'cgtn',
      name: 'CGTN',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '194'
      }, {
        id: 'btv',
        no: '161'
      }, {
        id: 'lguplus',
        no: '119'
      }],
      lang: 'zh',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cgtn.png'
    },
    {
      id: 'foxnews',
      name: 'Fox News',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '195'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/foxnews.png'
    },
    {
      id: 'bloomberg',
      name: 'Bloomberg',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '196'
      }, {
        id: 'btv',
        no: '162'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/bloomberg.png'
    },
    {
      id: 'cnbc',
      name: 'CNBC',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '197'
      }, {
        id: 'lguplus',
        no: '118'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cnbc.png'
    },
    {
      id: 'tv5monde',
      name: 'TV5MONDE',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '198'
      }, {
        id: 'btv',
        no: '279'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/tv5monde.png'
    },
    {
      id: 'nhkwp',
      name: 'NHK World Premium',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '199'
      }, {
        id: 'btv',
        no: '278'
      }, {
        id: 'lguplus',
        no: '143'
      }, {
        id: 'skylife',
        no: '175'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/nhkwp.png'
    },
    {
      id: 'arirangtv',
      name: 'Arirang TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '200'
      }, {
        id: 'btv',
        no: '270'
      }, {
        id: 'lguplus',
        no: '141'
      }, {
        id: 'skylife',
        no: '98'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/arirangtv.png'
    },
    {
      id: 'dogtv',
      name: 'DOG TV',
      genre: 'life',
      preset: [{
        id: 'ollehtv',
        no: '201'
      }, {
        id: 'btv',
        no: '79'
      }, {
        id: 'lguplus',
        no: '89'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/dogtv.png'
    },
    {
      id: 'channelhappydog',
      name: 'Channel Happy Dog',
      genre: 'life',
      preset: [{
        id: 'ollehtv',
        no: '203'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/channelhappydog.png'
    },
    {
      id: 'viki',
      name: 'Viki',
      genre: 'movie',
      preset: [{
        id: 'ollehtv',
        no: '204'
      }, {
        id: 'btv',
        no: '322'
      }, {
        id: 'lguplus',
        no: '292'
      }, {
        id: 'skylife',
        no: '300'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/viki.png'
    },
    {
      id: 'midnight',
      name: 'Midnight',
      genre: 'movie',
      preset: [{
        id: 'ollehtv',
        no: '205'
      }, {
        id: 'btv',
        no: '321'
      }, {
        id: 'lguplus',
        no: '291'
      }, {
        id: 'skylife',
        no: '302'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/midnight.png'
    },
    {
      id: 'playboytv',
      name: 'Playboy TV',
      genre: 'movie',
      preset: [{
        id: 'ollehtv',
        no: '206'
      }, {
        id: 'btv',
        no: '320'
      }, {
        id: 'lguplus',
        no: '290'
      }, {
        id: 'skylife',
        no: '301'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/playboytv.png'
    },
    {
      id: 'honeytv',
      name: 'Honey TV',
      genre: 'movie',
      preset: [{
        id: 'ollehtv',
        no: '207'
      }, {
        id: 'btv',
        no: '323'
      }, {
        id: 'lguplus',
        no: '293'
      }, {
        id: 'skylife',
        no: '303'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/honeytv.png'
    },
    {
      id: 'pinkhousetv',
      name: 'Pinkhouse TV',
      genre: 'movie',
      preset: [{
        id: 'ollehtv',
        no: '208'
      }, {
        id: 'btv',
        no: '324'
      }, {
        id: 'lguplus',
        no: '295'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/pinkhousetv.png'
    },
    {
      id: 'lawtv',
      name: 'Law TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '213'
      }, {
        id: 'btv',
        no: '280'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/lawtv.png'
    },
    {
      id: 'tbstv',
      name: 'tbs TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '214'
      }, {
        id: 'btv',
        no: '272'
      }, {
        id: 'lguplus',
        no: '176'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/tbstv.png'
    },
    {
      id: 'childcaretv',
      name: 'Childcare TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '217'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/childcaretv.png'
    },
    {
      id: 'welfaretv',
      name: 'Welfare TV',
      genre: 'public',
      preset: [{
        id: 'ollehtv',
        no: '219'
      }, {
        id: 'btv',
        no: '293'
      }, {
        id: 'lguplus',
        no: '173'
      }, {
        id: 'skylife',
        no: '188'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/welfaretv.png'
    },
    {
      id: 'cookiehealthytv',
      name: 'Cookie Healthy TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '220'
      }, {
        id: 'btv',
        no: '269'
      }, {
        id: 'lguplus',
        no: '144'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cookiehealthytv.png'
    },
    {
      id: 'amc',
      name: 'AMC',
      genre: 'series',
      preset: [{
        id: 'ollehtv',
        no: '221'
      }, {
        id: 'btv',
        no: '100'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/amc.png'
    },
    {
      id: 'dscscience',
      name: 'DSC Science',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '222'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/dscscience.png'
    },
    {
      id: 'hgtv',
      name: 'HGTV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '223'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/hgtv.png'
    },
    {
      id: 'davinchilearning',
      name: 'Davinchi learning',
      genre: 'education',
      preset: [{
        id: 'ollehtv',
        no: '224'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/davinchilearning.png'
    },
    {
      id: 'eent',
      name: 'E! Ent',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '225'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/eent.png'
    },
    {
      id: 'channelw',
      name: 'Channel W',
      genre: 'series',
      preset: [{
        id: 'ollehtv',
        no: '226'
      }, {
        id: 'lguplus',
        no: '195'
      }, {
        id: 'skylife',
        no: '139'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/channelw.png'
    },
    {
      id: 'knettv',
      name: 'K-NET TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '230'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/knettv.png'
    },
    {
      id: 'catholicbroadc',
      name: 'Catholic Broadc.',
      genre: 'religion',
      preset: [{
        id: 'ollehtv',
        no: '231'
      }, {
        id: 'btv',
        no: '307'
      }, {
        id: 'lguplus',
        no: '184'
      }, {
        id: 'skylife',
        no: '184'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/catholicbroadc.png'
    },
    {
      id: 'bbsbuddhistbroadc',
      name: 'BBS buddhist Broadc.',
      genre: 'religion',
      preset: [{
        id: 'ollehtv',
        no: '232'
      }, {
        id: 'btv',
        no: '305'
      }, {
        id: 'lguplus',
        no: '186'
      }, {
        id: 'skylife',
        no: '181'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/bbsbuddhistbroadc.png'
    },
    {
      id: 'btnbuddhisttv',
      name: 'BTN Buddhist TV',
      genre: 'religion',
      preset: [{
        id: 'ollehtv',
        no: '233'
      }, {
        id: 'btv',
        no: '306'
      }, {
        id: 'lguplus',
        no: '185'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/btnbuddhisttv.png'
    },
    {
      id: 'goodtv',
      name: 'Good TV',
      genre: 'religion',
      preset: [{
        id: 'ollehtv',
        no: '234'
      }, {
        id: 'btv',
        no: '303'
      }, {
        id: 'skylife',
        no: '193'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/goodtv.png'
    },
    {
      id: 'cchannel',
      name: 'C Channel',
      genre: 'religion',
      preset: [{
        id: 'ollehtv',
        no: '235'
      }, {
        id: 'btv',
        no: '304'
      }, {
        id: 'lguplus',
        no: '182'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cchannel.png'
    },
    {
      id: 'ctschristiantv',
      name: 'CTS Christian TV',
      genre: 'religion',
      preset: [{
        id: 'ollehtv',
        no: '236'
      }, {
        id: 'btv',
        no: '301'
      }, {
        id: 'lguplus',
        no: '180'
      }, {
        id: 'skylife',
        no: '183'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ctschristiantv.png'
    },
    {
      id: 'cgntv',
      name: 'CGNTV',
      genre: 'religion',
      preset: [{
        id: 'ollehtv',
        no: '237'
      }, {
        id: 'btv',
        no: '302'
      }, {
        id: 'lguplus',
        no: '183'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cgntv.png'
    },
    {
      id: 'cbs',
      name: 'CBS',
      genre: 'religion',
      preset: [{
        id: 'ollehtv',
        no: '238'
      }, {
        id: 'btv',
        no: '300'
      }, {
        id: 'lguplus',
        no: '181'
      }, {
        id: 'skylife',
        no: '182'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cbs.png'
    },
    {
      id: 'channeli',
      name: 'Channel i',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '250'
      }, {
        id: 'btv',
        no: '281'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/channeli.png'
    },
    {
      id: 'trendy',
      name: 'TRENDY',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '251'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/trendy.png'
    },
    {
      id: 'koreajobbroadc',
      name: 'Korea Job Broadc.',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '252'
      }, {
        id: 'btv',
        no: '273'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/koreajobbroadc.png'
    },
    {
      id: 'hqplus',
      name: 'HQ+',
      genre: 'entertainment',
      preset: [{
        id: 'ollehtv',
        no: '253'
      }, {
        id: 'btv',
        no: '47'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/hqplus.png'
    },
    {
      id: 'medicaltv',
      name: 'Medical TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '254'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/medicaltv.png'
    },
    {
      id: 'smallbussinessbroadc',
      name: 'Small Bussiness Broadc.',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '255'
      }, {
        id: 'btv',
        no: '271'
      }, {
        id: 'lguplus',
        no: '175'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/smallbussinessbroadc.png'
    },
    {
      id: 'dwtvasiaplus',
      name: 'DW-TV Asia+',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '257'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/dwtvasiaplus.png'
    },
    {
      id: 'australiaplus',
      name: 'Australia PLUS',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '258'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/australiaplus.png'
    },
    {
      id: 'horseridingbroadc',
      name: 'Horse Riding Broadc.',
      genre: 'hobby',
      preset: [{
        id: 'ollehtv',
        no: '259'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/horseridingbroadc.png'
    },
    {
      id: 'militarytv',
      name: 'Military TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '260'
      }, {
        id: 'btv',
        no: '282'
      }, {
        id: 'lguplus',
        no: '174'
      }, {
        id: 'skylife',
        no: '163'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/militarytv.png'
    },
    {
      id: 'stbbroadc',
      name: 'STB Broadc.',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '261'
      }, {
        id: 'btv',
        no: '308'
      }, {
        id: 'lguplus',
        no: '187'
      }, {
        id: 'skylife',
        no: '185'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/stbbroadc.png'
    },
    {
      id: 'cmtv',
      name: 'CMTV',
      genre: 'religion',
      preset: [{
        id: 'ollehtv',
        no: '262'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cmtv.png'
    },
    {
      id: 'eventtv',
      name: 'Event TV',
      genre: 'music',
      preset: [{
        id: 'ollehtv',
        no: '263'
      }, {
        id: 'btv',
        no: '238'
      }, {
        id: 'lguplus',
        no: '103'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/eventtv.png'
    },
    {
      id: 'seniortv',
      name: 'Senior TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '264'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/seniortv.png'
    },
    {
      id: 'consumertv',
      name: 'Consumer TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '265'
      }, {
        id: 'btv',
        no: '275'
      }, {
        id: 'lguplus',
        no: '177'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/consumertv.png'
    },
    {
      id: 'silveritv',
      name: 'Silver-i TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '266'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/silveritv.png'
    },
    {
      id: 'stn',
      name: 'STN',
      genre: 'sports',
      preset: [{
        id: 'ollehtv',
        no: '267'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/stn.png'
    },
    {
      id: 'docuone',
      name: 'Docu one',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '269'
      }, {
        id: 'btv',
        no: '283'
      }, {
        id: 'lguplus',
        no: '129'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/docuone.png'
    },
    {
      id: 'bridgetv',
      name: 'Bridge TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '270'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/bridgetv.png'
    },
    {
      id: 'healthmeditv',
      name: 'Health Medi TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '271'
      }, {
        id: 'btv',
        no: '268'
      }, {
        id: 'lguplus',
        no: '138'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/healthmeditv.png'
    },
    {
      id: 'electionbroadc',
      name: 'Election Broadc.',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '273'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/electionbroadc.png'
    },
    {
      id: 'livingtv',
      name: 'Living TV',
      genre: 'hobby',
      preset: [{
        id: 'ollehtv',
        no: '276'
      }, {
        id: 'btv',
        no: '251'
      }, {
        id: 'skylife',
        no: '125'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/livingtv.png'
    },
    {
      id: 'indiefilm',
      name: 'Indie Film',
      genre: 'movie',
      preset: [{
        id: 'ollehtv',
        no: '277'
      }, {
        id: 'btv',
        no: '61'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/indiefilm.png'
    },
    {
      id: 'socialsafetybroadc',
      name: 'Social Safety Broadc.',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '278'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/socialsafetybroadc.png'
    },
    {
      id: 'jjclocalgovtv',
      name: 'JJC Local-gov TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '279'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/jjclocalgovtv.png'
    },
    {
      id: 'cctv4',
      name: 'CCTV4',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '280'
      }, {
        id: 'btv',
        no: '277'
      }, {
        id: 'lguplus',
        no: '120'
      }, {
        id: 'skylife',
        no: '177'
      }],
      lang: 'zh',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cctv4.png'
    },
    {
      id: 'kbsnlife',
      name: 'KBSN Life',
      genre: 'life',
      preset: [{
        id: 'ollehtv',
        no: '281'
      }, {
        id: 'skylife',
        no: '135'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kbsnlife.png'
    },
    {
      id: 'sportsforalltv',
      name: 'Sports for all TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '282'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/sportsforalltv.png'
    },
    {
      id: 'multiculturetv',
      name: 'Multi-culture TV',
      genre: 'information',
      preset: [{
        id: 'ollehtv',
        no: '283'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/multiculturetv.png'
    },
    {
      id: 'wonbulbroadc',
      name: 'Wonbul Broadc.',
      genre: 'religion',
      preset: [{
        id: 'ollehtv',
        no: '284'
      }, {
        id: 'btv',
        no: '309'
      }, {
        id: 'lguplus',
        no: '188'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/wonbulbroadc.png'
    },
    {
      id: 'nbntv',
      name: 'nbn TV',
      genre: 'news',
      preset: [{
        id: 'ollehtv',
        no: '285'
      }, {
        id: 'btv',
        no: '164'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/nbntv.png'
    },
    {
      id: 'dogandmom',
      name: 'dogandmom',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '609'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/dogandmom.png'
    },
    {
      id: 'newfavkpop',
      name: '최신 인기 가요',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '610'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'newballardkpop',
      name: '최신 발라드 가요',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '611'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'newkpopdance',
      name: '최신 가요 댄스',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '612'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'newkpopchart',
      name: '최신 가요 차트',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '613'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'trotsongstage',
      name: '트로트가요무대',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '614'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'latesttrothit',
      name: '최신 트로트 히트',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '615'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: '80sand90s',
      name: '80, 90년대 가요',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '616'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'housewifeissinging',
      name: '주부 애창 가요',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '617'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'latesthitpops',
      name: '최신 히트 팝스',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '618'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'popnostalgia',
      name: 'Pop Nostalgia',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '619'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'multiculturalmusic1',
      name: '다문화 음악 1',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '620'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'multiculturalmusic2',
      name: '다문화 음악 2',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '621'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'blackmusic',
      name: 'Black Music',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '622'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'rockfestival',
      name: 'Rock Festival',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '623'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'allthatjazz',
      name: 'All That Jazz',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '624'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'homeclassic',
      name: '홈클래식',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '625'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'christianmusic',
      name: '기독교 음악',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '626'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'buddhistmusic',
      name: '불교 음악',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '627'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'catholicmusic',
      name: '카톨릭 음악',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '628'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'popularmusicontv',
      name: 'TV 속 화제음악',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '629'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'ostheaven',
      name: 'OST 천국',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '630'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'eqshakewithmom',
      name: '엄마랑 EQ동요',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '631'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'rainyday',
      name: 'Rainy Day',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '632'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'ladieschoice',
      name: '레이디스초이스',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '633'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'kpopallstars',
      name: 'K-pop Allstars',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '634'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'loveballad',
      name: '러브 발라드',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '635'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'coffeetime',
      name: '커피타임',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '636'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'clubmusic',
      name: '클럽뮤직',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '637'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'powerstation',
      name: '파워스테이션',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '638'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'coolnhot',
      name: 'Cool & Hot',
      genre: 'audio',
      preset: [{
        id: 'ollehtv',
        no: '639'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/audio.png'
    },
    {
      id: 'cnnus',
      name: 'CNN US',
      genre: 'news',
      preset: [{
        id: 'btv',
        no: '159'
      }, {
        id: 'skylife',
        no: '171'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cnnus.png'
    },
    {
      id: 'channelnewsasia',
      name: 'Channel News Asia',
      genre: 'news',
      preset: [{
        id: 'btv',
        no: '163'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/channelnewsasia.png'
    },
    {
      id: 'eurosports',
      name: 'Eurosports',
      genre: 'sports',
      preset: [{
        id: 'btv',
        no: '134'
      }, {
        id: 'skylife',
        no: '176'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/eurosports.png'
    },
    {
      id: 'screengolfzon',
      name: 'Screen GOLFZON',
      genre: 'sports',
      preset: [{
        id: 'btv',
        no: '138'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/screengolfzon.png'
    },
    {
      id: 'indoorsports',
      name: 'Indoor Sports TV',
      genre: 'sports',
      preset: [{
        id: 'btv',
        no: '139'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/indoorsports.png'
    },
    {
      id: 'uxn',
      name: 'uxn',
      genre: 'drama',
      preset: [{
        id: 'btv',
        no: '70'
      }, {
        id: 'lguplus',
        no: '2'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/uxn.png'
    },
    {
      id: 'uhddreamtv',
      name: 'UHD Dream TV',
      genre: 'drama',
      preset: [{
        id: 'btv',
        no: '71'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/uhddreamtv.png'
    },
    {
      id: 'asiauhd',
      name: 'Asia UHD',
      genre: 'drama',
      preset: [{
        id: 'btv',
        no: '72'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/asiauhd.png'
    },
    {
      id: 'umax',
      name: 'UMAX',
      genre: 'drama',
      preset: [{
        id: 'btv',
        no: '73'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/umax.png'
    },
    {
      id: 'insighttv',
      name: 'INSIGHT TV',
      genre: 'entertainment',
      preset: [{
        id: 'btv',
        no: '74'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/insighttv.png'
    },
    {
      id: 'cubetv',
      name: 'CUBE TV',
      genre: 'entertainment',
      preset: [{
        id: 'btv',
        no: '89'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cubetv.png'
    },
    {
      id: 'fx',
      name: 'FX',
      genre: 'entertainment',
      preset: [{
        id: 'btv',
        no: '90'
      }, {
        id: 'skylife',
        no: '120'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/fx.png'
    },
    {
      id: 'mypettv',
      name: 'MY PET TV',
      genre: 'entertainment',
      preset: [{
        id: 'btv',
        no: '92'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/mypettv.png'
    },
    {
      id: 'ont',
      name: 'ONT',
      genre: 'hobby',
      preset: [{
        id: 'btv',
        no: '245'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ont.png'
    },
    {
      id: 'fashionn',
      name: 'Fashion N',
      genre: 'life',
      preset: [{
        id: 'btv',
        no: '211'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/fashionn.png'
    },
    {
      id: 'lifen',
      name: 'Life N',
      genre: 'life',
      preset: [{
        id: 'btv',
        no: '215'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/lifen.png'
    },
    {
      id: 'foxlife',
      name: 'Fox life',
      genre: 'life',
      preset: [{
        id: 'btv',
        no: '216'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/foxnews.png'
    },
    {
      id: 'nhkworldtv',
      name: 'NHK WORLD TV',
      genre: 'life',
      preset: [{
        id: 'btv',
        no: '221'
      }, {
        id: 'lguplus',
        no: '142'
      }],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/nhkworldtv.png'
    },
    {
      id: 'cinef',
      name: 'Cinef',
      genre: 'movie',
      preset: [{
        id: 'btv',
        no: '58'
      }, {
        id: 'lguplus',
        no: '42'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cinef.png'
    },
    {
      id: 'celestialmovies',
      name: 'Celestial Movies',
      genre: 'movie',
      preset: [{
        id: 'btv',
        no: '62'
      }],
      lang: 'zh',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/celestialmovies.png'
    },
    {
      id: 'desiretv',
      name: 'Desire TV',
      genre: 'movie',
      preset: [{
        id: 'btv',
        no: '325'
      }, {
        id: 'lguplus',
        no: '294'
      }, {
        id: 'skylife',
        no: '304'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/desiretv.png'
    },
    {
      id: 'iconcerts',
      name: 'i-Concerts',
      genre: 'movie',
      preset: [{
        id: 'btv',
        no: '236'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/iconcerts.png'
    },
    {
      id: 'cmusictv',
      name: 'C Music TV',
      genre: 'movie',
      preset: [{
        id: 'btv',
        no: '237'
      }, {
        id: 'skylife',
        no: '114'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cmusictv.png'
    },
    {
      id: 'bet',
      name: 'BET',
      genre: 'movie',
      preset: [{
        id: 'btv',
        no: '239'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/bet.png'
    },
    {
      id: 'channelching',
      name: 'Channel ching',
      genre: 'series',
      preset: [{
        id: 'btv',
        no: '105'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/channelching.png'
    },
    {
      id: 'singitv',
      name: 'Kids Land TV',
      genre: 'kids',
      preset: [{
        id: 'btv',
        no: '188'
      }, {
        id: 'lguplus',
        no: '147'
      }, {
        id: 'skylife',
        no: '41'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/singitv.png'
    },
    {
      id: 'ebsu',
      name: 'EBS U',
      genre: 'education',
      preset: [{
        id: 'lguplus',
        no: '168'
      }],
      lang: '',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ebsu.png'
    },
    {
      id: 'mtn',
      name: 'MTN',
      genre: 'news',
      preset: [{
        id: 'lguplus',
        no: '122'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/mtn.png'
    },
    {
      id: 'nikelodian',
      name: 'Nikelodian',
      genre: 'animation',
      preset: [{
        id: 'lguplus',
        no: '154'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/nikelodian.png'
    },
    {
      id: 'odc',
      name: 'Outdoor Channel',
      genre: 'hobby',
      preset: [{
        id: 'lguplus',
        no: '135'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/odc.png'
    },
    {
      id: 'sbsplusuhd',
      name: 'SBS Plus UHD',
      genre: 'drama',
      preset: [{
        id: 'lguplus',
        no: '200'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/sbsplus.png'
    },
    {
      id: 'spotvon1',
      name: 'SPOTV ON 1',
      genre: 'sports',
      preset: [{
        id: 'lguplus',
        no: '198'
      }, {
        id: 'skylife',
        no: '271'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/spotvon1.png'
    },
    {
      id: 'spotvon2',
      name: 'SPOTV ON 2',
      genre: 'sports',
      preset: [{
        id: 'lguplus',
        no: '199'
      }, {
        id: 'skylife',
        no: '272'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/spotvon2.png'
    },
    {
      id: 'cctvnews',
      name: 'CCTV News',
      genre: 'news',
      preset: [{
        id: 'skylife',
        no: '178'
      }],
      lang: 'zh',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/cctvnews.png'
    },
    {
      id: 'bbcworldservice',
      name: 'BBC World Service',
      genre: 'news',
      preset: [{
        id: 'skylife',
        no: '310'
      }],
      lang: 'en',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/bbcworldservice.png'
    },
    {
      id: 'worktv',
      name: 'WorkTV',
      genre: 'information',
      preset: [{
        id: 'skylife',
        no: '189'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/worktv.png'
    },
    {
      id: 'mtv',
      name: 'MTV',
      genre: 'music',
      preset: [{
        id: 'skylife',
        no: '113'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/mtv.png'
    },
    {
      id: 'wbsi',
      name: 'WBS원음방송',
      genre: 'music',
      preset: [{
        id: 'skylife',
        no: '187'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/wbsi.png'
    },
    {
      id: 'satiolatest',
      name: 'Satio 최신 인기가요',
      genre: 'music',
      preset: [{
        id: 'skylife',
        no: '311'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/satiomusic.png'
    },
    {
      id: 'satioballad',
      name: 'Satio 인기 발라드가요',
      genre: 'music',
      preset: [{
        id: 'skylife',
        no: '312'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/satiomusic.png'
    },
    {
      id: 'satiodance',
      name: 'Satio 인기 댄스 가요',
      genre: 'music',
      preset: [{
        id: 'skylife',
        no: '313'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/satiomusic.png'
    },
    {
      id: 'satioclassic',
      name: 'Satio 홈클래식',
      genre: 'music',
      preset: [{
        id: 'skylife',
        no: '314'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/satiomusic.png'
    },
    {
      id: 'satiotrot',
      name: 'Satio 트로트 가요무대',
      genre: 'music',
      preset: [{
        id: 'skylife',
        no: '315'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/satiomusic.png'
    },
    {
      id: 'satioadult',
      name: 'Satio 인기 성인 가요',
      genre: 'music',
      preset: [{
        id: 'skylife',
        no: '316'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/satiomusic.png'
    },
    {
      id: 'kisslatest',
      name: 'KISS 최신 인기가요',
      genre: 'music',
      preset: [{
        id: 'skylife',
        no: '331'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kissmusic.png'
    },
    {
      id: 'kisskpop',
      name: 'KISS K-POP 아이돌',
      genre: 'music',
      preset: [{
        id: 'skylife',
        no: '332'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kissmusic.png'
    },
    {
      id: 'kissballad',
      name: 'KISS 발라드',
      genre: 'music',
      preset: [{
        id: 'skylife',
        no: '333'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kissmusic.png'
    },
    {
      id: 'kisspop',
      name: 'KISS Pop Nostalgia',
      genre: 'music',
      preset: [{
        id: 'skylife',
        no: '334'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kissmusic.png'
    },
    {
      id: 'kisstrot',
      name: 'KISS 트로트 아리랑',
      genre: 'music',
      preset: [{
        id: 'skylife',
        no: '335'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kissmusic.png'
    },
    {
      id: 'kissclassic',
      name: 'Kiss Classic Fantasia',
      genre: 'music',
      preset: [{
        id: 'skylife',
        no: '336'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/kissmusic.png'
    },
    {
      id: 'gongyoungshop',
      name: '공영쇼핑',
      genre: 'shopping',
      preset: [{
        id: 'skylife',
        no: '21'
      }],
      lang: 'ko',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/gongyoungshop.png'
    },
    {
      id: 'nhkmainchannel',
      name: 'NHK-Main Channel',
      genre: 'totaltv',
      preset: [
        {
          id: 'tokyo1',
          no: 'Terrestrial Digital#1'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/nhkmainchannel.png'
    },
    {
      id: 'nhkeducationalchannel',
      name: 'NHK-Educational Channel',
      genre: 'education',
      preset: [
        {
          id: 'tokyo1',
          no: 'Terrestrial Digital#2'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/nhkeducationalchannel.png'
    },
    {
      id: 'ntv',
      name: 'NTV',
      genre: 'totaltv',
      preset: [
        {
          id: 'tokyo1',
          no: 'Terrestrial Digital#3'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/ntv.png'
    },
    {
      id: 'tvasahi',
      name: 'TV Asahi',
      genre: 'totaltv',
      preset: [
        {
          id: 'tokyo1',
          no: 'Terrestrial Digital#5'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/tvasahi.png'
    },
    {
      id: 'tbs',
      name: 'TBS TV',
      genre: 'totaltv',
      preset: [
        {
          id: 'tokyo1',
          no: 'Terrestrial Digital#6'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/tbs.png'
    },
    {
      id: 'tvtokyo',
      name: 'TV Tokyo',
      genre: 'totaltv',
      preset: [
        {
          id: 'tokyo1',
          no: 'Terrestrial Digital#7'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/tvtokyo.png'
    },
    {
      id: 'fujitv',
      name: 'Fuji TV',
      genre: 'totaltv',
      preset: [
        {
          id: 'tokyo1',
          no: 'Terrestrial Digital#8'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/fujitv.png'
    },
    {
      id: 'tokyomx',
      name: 'TOKYO MX',
      genre: 'totaltv',
      preset: [
        {
          id: 'tokyo1',
          no: 'Terrestrial Digital#9'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/tokyomx.png'
    },
    {
      id: 'jp-bbc',
      name: 'BBC',
      genre: 'news',
      preset: [
        {
          id: 'tokyo1',
          no: 'Terrestrial Digital#10'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/bbc.png'
    },
    {
      id: 'nhkbs1',
      name: 'NHK BS-1',
      genre: 'totaltv',
      preset: [
        {
          id: 'tokyo1',
          no: 'BS#1'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/nhkbs1.png'
    },
    {
      id: 'nhkbspremium',
      name: 'NHK BS Premium',
      genre: 'entertainment',
      preset: [
        {
          id: 'tokyo1',
          no: 'BS#3'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/nhkbspremium.png'
    },
    {
      id: 'bsntv',
      name: 'BS NTV',
      genre: 'totaltv',
      preset: [
        {
          id: 'tokyo1',
          no: 'BS#4'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/bsntv.png'
    },
    {
      id: 'bsasahi',
      name: 'BS Asahi',
      genre: 'totaltv',
      preset: [
        {
          id: 'tokyo1',
          no: 'BS#5'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/bsasahi.png'
    },
    {
      id: 'bstbs',
      name: 'BS TBS',
      genre: 'totaltv',
      preset: [
        {
          id: 'tokyo1',
          no: 'BS#6'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/bstbs.png'
    },
    {
      id: 'bstvtokyo',
      name: 'BS TV TOKYO',
      genre: 'totaltv',
      preset: [
        {
          id: 'tokyo1',
          no: 'BS#7'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/bstvtokyo.png'
    },
    {
      id: 'bsfuji',
      name: 'BS Fuji',
      genre: 'totaltv',
      preset: [
        {
          id: 'tokyo1',
          no: 'BS#8'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/bsfuji.png'
    },
    {
      id: 'bs11',
      name: 'BS 11',
      genre: 'totaltv',
      preset: [
        {
          id: 'tokyo1',
          no: 'BS#11'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/bs11.png'
    },
    {
      id: 'bs12twellv',
      name: 'BS12 TwellV',
      genre: 'entertainment',
      preset: [
        {
          id: 'tokyo1',
          no: 'BS#12'
        }
      ],
      lang: 'ja',
      logo: 'https://istay.s3.ap-northeast-2.amazonaws.com/html/castit/viewer/channelLogo/bs12twellv.png'
    }
  ],
  preset: [
    {
      id: 'ollehtv',
      name: 'Olleh TV'
    },
    {
      id: 'btv',
      name: 'B TV'
    },
    {
      id: 'lguplus',
      name: 'LG U+'
    },
    {
      id: 'skylife',
      name: 'Sky Life'
    },
    {
      id: 'tokyo1',
      name: 'Tokyo1'
    }
  ],
  genre: [
    'entertainment',
    'shopping',
    'drama',
    'terrestrial',
    'totaltv',
    'news',
    'movie',
    'music',
    'sports',
    'public',
    'life',
    'hobby',
    'series',
    'animation',
    'kids',
    'education',
    'information',
    'religion',
    'audio'
  ],
  lang: [
    'ko',
    'en',
    'ja',
    'zh'
  ]
}

export default TVCHANNEL
